import React from 'react';
import { getModelResolutionValues } from '../utils/imageSize';
import { ModelParamBadges } from './ModelParamBadges';

const TIER_ORDER = ['512', '1K', '2K', '4K'];

function sortResolutions(values) {
    return [...values].sort((a, b) => {
        const ai = TIER_ORDER.indexOf(a);
        const bi = TIER_ORDER.indexOf(b);
        if (ai === -1 && bi === -1) return String(a).localeCompare(String(b));
        if (ai === -1) return 1;
        if (bi === -1) return -1;
        return ai - bi;
    });
}

/** Компактные бейджи resolution-values рядом с названием модели */
const ModelResolutionIcons = ({ supportedParameters, isDark = false }) => {
    const values = sortResolutions(getModelResolutionValues(supportedParameters));
    if (!values.length) return null;

    return (
        <ModelParamBadges
            values={values}
            isDark={isDark}
            title={`Разрешения: ${values.join(', ')}`}
            className="shrink"
        />
    );
};

export default ModelResolutionIcons;
